import { useState } from 'react';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Tooltip from '@mui/material/Tooltip';

function ScrollToTopButton() {
    const [isVisible, setIsVisible] = useState(false);

    // Function to scroll to the top of the page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    // Function to show/hide the button based on the scroll position
    const handleScroll = () => {
        if (window.scrollY > 100) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    // Attach the scroll event listener
    window.addEventListener('scroll', handleScroll);

    return (
        <Tooltip arrow placement="top" title="Scroll to top">
            <div
                style={{
                    position: 'fixed',
                    bottom: '0',
                    right: '0',
                    marginBottom: '3rem',
                    marginRight: '3rem',
                    opacity: isVisible ? '0.5' : '0',
                    zIndex: isVisible ? '3' : '0',
                }}
            >
                <button
                    style={{
                        backgroundColor: '#4caf50', // Adjust the color code as needed for a brighter appearance
                        padding: '50%',
                        border: 'none',
                        borderRadius: '50%',
                    }}
                    onClick={scrollToTop}
                >
                    <KeyboardDoubleArrowUpIcon />
                </button>
            </div>
        </Tooltip>
    );
}

export default ScrollToTopButton;
